<app-animation [fps]="effectiveFps"></app-animation>

<pose-viewer
  #poseViewer
  [attr.src]="src"
  [attr.autoplay]="false"
  [attr.loop]="false"
  width="10px"
  height="10px"></pose-viewer>
